import React from 'react';
import { Pressable } from 'react-native-gesture-handler';

import ShareArrowIcon from '@/assets/icons/share-arrow';
import { InnerBorder } from '@/components/InnerBorder';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const BORDER_COLOR = ds.colorValue.border.subtle;

type Props = {
    onPress: () => void;
};

/** Renders the circular share button (share icon on a neutral surface) used in entry card bottoms. */
export const EntryCardShareButton = ({ onPress }: Props) => {
    return (
        <Pressable onPress={onPress} accessibilityRole="button">
            <Box
                width={40}
                height={40}
                borderRadius="r40"
                backgroundColor={ds.colorToken.background.neutral.subtle}
                alignItems="center"
                justifyContent="center"
            >
                <InnerBorder borderRadius="r40" borderColor={BORDER_COLOR} />
                <ShareArrowIcon color={designSystem.colors.neutral300} width={20} height={20} />
            </Box>
        </Pressable>
    );
};
